<template>
  <div v-if="topic.stories" class="m-10">
    <div class="m-b-40">
      <el-form v-if="edit" @submit.native.prevent>
        <el-autocomplete
          prefix-icon="el-icon-search"
          placeholder="Ajouter un contenu"
          v-model="storyTitle"
          :trigger-on-focus="false"
          :highlight-first-item="true"
          :fetch-suggestions="storiesFilter"
          @select="selectStory"
        ></el-autocomplete>
      </el-form>
      <table class="table">
        <tbody v-if="topic.stories.length == 0">
          <tr>
            <td colspan="4" class="text-center">
              <em class="text-muted">Pas de contenu associé pour l'instant</em>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr v-for="story in topic.stories" :key="story.id">
            <td>
              <el-image
                style="width: 70px; height: 70px"
                :src="story.thumb_story_list_url"
                fit="contain"
              ></el-image>
            </td>
            <td>
              <h5 class="m-b-10" :class="{'text-muted': !story.title}">
                {{ story.title || 'Aucun titre' }}
                <br />
                <small>
                  <span v-if="story.primary_category && story.primary_category.label">
                    <span>
                      <i class="fa fa-folder-o"></i>
                      <span
                        :class="{'badge-success': story.status == 'PUBLISHED', 'badge-danger': story.status == 'DISABLED'}"
                        class="badge m-l-5 m-r-5"
                      >{{ story.status | translate }}</span>
                      {{ story.primary_category.label }}
                    </span>
                    - Publié le
                    {{ story.published_at | formatDate }}
                  </span>
                </small>
              </h5>
            </td>
            <td v-if="edit">
              <a href @click.prevent="deleteStory(story.id)" class="btn btn-warning btn-sm">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "topic-stories",
  props: {
    edit: { type: Boolean, default: false },
    mask: { type: String, default: "*" }
  },
  computed: mapGetters({
    topic: "topic"
  }),
  data() {
    return {
      storyTitle: null
    };
  },
  methods: {
    storiesFilter(queryString, cb) {
      if (queryString) {
        this.axios
          .get("/stories/", {
            params: {
              term: queryString,
              scope: "PUBLIC",
              per_page: 100
            },
            headers: { "x-fields": "id,title" }
          })
          .then(response => {
            var list = [];
            response.data.results.map(function(value, key) {
              list.push({
                value: `${value.title}`,
                id: value.id,
                story: value
              });
            });
            cb(list);
          });
      }
    },
    selectStory(value) {
      if (value) {
        this.storyTitle = null;
        this.$store
          .dispatch("addTopicStory", {
            topic_id: this.topic.id,
            story_id: value.id,
            headers: {
              "X-Fields": this.mask
            }
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Contenu ajouté avec succès."
            });
          });
      }
    },
    deleteStory(storyId) {
      this.$confirm("Supprimer l’association. Continuer ?", "Warning", {
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        type: "warning"
      })
        .then(() => {
          this.$store
            .dispatch("deleteTopicStory", {
              topic_id: this.topic.id,
              story_id: storyId,
              headers: {
                "X-Fields": this.mask
              }
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Association supprimée"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée"
          });
        });
    }
  }
};
</script>
<style scoped>
.el-autocomplete {
  display: block;
}
</style>
